import { GenericActions } from "../../redux/generic-actions";
import { componentsReducer } from "../../redux/root.reducer";

export function multiselectFilterReducerFactory(rootProp, initialState) {
    return function multiselectFilterReducer(state = initialState, action) {
        state = componentsReducer(rootProp, state, action);
        switch (action.type) {
            case `${rootProp}::${GenericActions.TOGGLE_SELECT}`:
                const index = action.payload;
                const filters = state.getIn([action.stateProp, "filters"])
                    .map((filter, i) => {
                        if (i === index) {
                            const currentState = filter.get("state");
                            return filter.set("state", !currentState);
                        } else {
                            return filter;
                        }
                    });
                return state.setIn([action.stateProp, "filters"], filters);

            case `${rootProp}::${GenericActions.STATE_RESET}`:
                return initialState;
            default:
                return state;
        }
    };
}
